import React from 'react';
import { Link } from 'react-router-dom';

const DigLogo = ({ variant = 'default' }) => {
  return (
    <Link
      to="/"
      className="inline-flex items-center select-none"
      aria-label="Duffy Investment Group home"
      data-testid="dig-logo"
    >
      <img
        src="/images/dig-logo-header.png"
        alt="Duffy Investment Group"
        className={`dig-logo dig-logo--${variant}`}
      />
    </Link>
  );
};

export default DigLogo;
